import { getFetchDataFunction } from '../DataTableService'

const includes = ['g_generator_user.hr_employee', 'conciliation', 'acc_account', 'acc_accounting_seat_status']

const route = process.env.VUE_APP_API_ROUTE + '/acc_accounting_seat/detailed'
const dtFetchData = getFetchDataFunction(route, includes)
export { dtFetchData }
